export default __webpack_public_path__ + "static/media/expl-nn_01_DE.0302f695.png";